import React from 'react';
import { SectionInstance } from '../types';

const CookieConsentBanner: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;

  const message: string = c.message || 'We use cookies to improve your experience and analyse site traffic.';
  const acceptText: string = c.accept_text || 'Accept All';
  const declineText: string = c.decline_text || 'Decline';
  const manageText: string = c.manage_text || '';
  const privacyUrl: string = c.privacy_url || '/privacy';
  const cookieUrl: string = c.cookie_policy_url || '';

  const linkStyle: React.CSSProperties = {
    color: 'var(--brand-accent, #c9a23b)',
    textDecoration: 'underline',
  };

  return (
    <aside style={{
      background: '#1e293b',
      color: '#fff',
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      <p style={{ flex: 1, margin: 0, fontSize: '0.875rem', minWidth: 200 }}>
        {message}{' '}
        <a href={privacyUrl} style={linkStyle}>Privacy Policy</a>
        {cookieUrl && (
          <> &amp; <a href={cookieUrl} style={linkStyle}>Cookie Policy</a></>
        )}
      </p>

      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        {manageText && (
          <button style={{
            padding: '8px 20px', borderRadius: 6,
            border: '1px solid rgba(255,255,255,0.3)', background: 'transparent',
            color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.875rem',
          }}>
            {manageText}
          </button>
        )}
        <button style={{
          padding: '8px 20px', borderRadius: 6,
          border: '1px solid rgba(255,255,255,0.3)', background: 'transparent',
          color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.875rem',
        }}>
          {declineText}
        </button>
        <button className="sb-cta-btn" style={{
          padding: '8px 20px', borderRadius: 6, border: 'none',
          background: 'var(--brand-primary, #2563eb)', color: '#fff',
          fontWeight: 600, cursor: 'pointer', fontSize: '0.875rem',
        }}>
          {acceptText}
        </button>
      </div>
    </aside>
  );
};

export default CookieConsentBanner;
